/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedResponse_IdpSessionResponse_ } from '../models/PaginatedResponse_IdpSessionResponse_';
import type { SignoutSessionRequest } from '../models/SignoutSessionRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileIdpSessionsService {
    /**
     * Get mobile user's active IDP sessions
     * Get all active IDP sessions for the authenticated mobile user
     * @param skip
     * @param limit
     * @param xMobileAuth
     * @returns PaginatedResponse_IdpSessionResponse_ Successful Response
     * @throws ApiError
     */
    public static getMyActiveMobileSessionsV1(
        skip?: number,
        limit: number = 100,
        xMobileAuth?: (string | null),
    ): CancelablePromise<PaginatedResponse_IdpSessionResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mobile/v1/idp-sessions/active',
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            query: {
                'skip': skip,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Sign out from a specific IDP session
     * Sign out the current user from a specific IDP session
     * @param requestBody
     * @param xMobileAuth
     * @returns any Successful Response
     * @throws ApiError
     */
    public static signOutSessionV1(
        requestBody: SignoutSessionRequest,
        xMobileAuth?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mobile/v1/idp-sessions/signout',
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Sign out current user from all other sessions
     * Sign out the current user from all active sessions except the current one
     * @param xMobileAuth
     * @returns any Successful Response
     * @throws ApiError
     */
    public static signoutCurrentUserFromAllOtherSessionsV1(
        xMobileAuth?: (string | null),
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mobile/v1/idp-sessions/signout-all-other-sessions',
            headers: {
                'X-Mobile-Auth': xMobileAuth,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
